/**
 * Language Selector
 */
export default class LanguageSelector {
    constructor(element, options) {
        this.wrapper = element;
        this.options = {
            flagSpriteSvg: '.js-language-selector-svg',
            ...options,
        };
    }

    /**
     * Init
     */
    init() {
        const select = this.wrapper.querySelector('select');

        select.value = LNG;

        if (select) {
            this.setFlag(select.value);

            select.addEventListener('change', (event) => {
                const languageCode = event.target.value;
                this.setFlag(languageCode);

                window.location.href = '/' + languageCode + '/';
            });
        }
    }

    setFlag(languageCode) {
        const svgEl = this.wrapper.querySelector(this.options.flagSpriteSvg);

        if (svgEl) {
            const svgUse = svgEl.querySelector('use');

            if (svgUse) {
                const fullPath = svgUse.getAttribute('xlink:href');
                const imagePath = fullPath.split('#')[0];
                svgUse.setAttribute('xlink:href', `${imagePath}#${languageCode}`);
            }
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const languageSelectors = Array.from(document.querySelectorAll('.js-language-selector'));
    languageSelectors.forEach((selector) => {
        const languageSelector = new LanguageSelector(selector);
        languageSelector.init();
    });
});
